import React from 'react';
import PropTypes from 'prop-types';
import { GoogleMapsContext } from '../../context/GoogleMapsProvider';
import StartView from './StartView';
import MapView from './MapView';
import { getLocationFromUrl, setLocationInUrl } from './utils/location';

const FindInstaller = (props) => {
    const { googleMapsApi } = React.useContext(GoogleMapsContext);
    const [urlLocation] = React.useState(getLocationFromUrl);
    const [selectedLocationCords, setSelectedLocationCords] = React.useState();
    const [selectedLocationQuery, setSelectedLocationQuery] = React.useState(urlLocation ? urlLocation.query : '');

    // Location from a shared link needs the Google Maps API to create a LatLng
    React.useEffect(() => {
        if (googleMapsApi && urlLocation) {
            setSelectedLocationCords(new googleMapsApi.LatLng(urlLocation.lat, urlLocation.lng));
        }
    }, [googleMapsApi]);

    const onSelect = (cords, query) => {
        setLocationInUrl(cords, query);
        setSelectedLocationQuery(query || '');
        setSelectedLocationCords(() => cords);
    };

    // Avoid flashing the start view while the location from the url is loading
    if (urlLocation && !selectedLocationCords) {
        return null;
    }

    return (
        <>
            {selectedLocationCords
                ? <MapView
                    selectedLocationCords={selectedLocationCords}
                    selectedLocationQuery={selectedLocationQuery}
                    placesEndpoint={props.placesEndpoint}
                    lang={props.lang}
                />
                : <StartView
                    lang={props.lang}
                    onSelect={onSelect}
                />
            }
        </>
    );
};

FindInstaller.propTypes = {
    placesEndpoint: PropTypes.string.isRequired
};

export default FindInstaller;
